import React from "react";
import { Container, Row, Col, Spinner, Modal, Alert } from "react-bootstrap";
import Header from "../../Common/Header";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheckCircle, 
  faInfoCircle,
} from "@fortawesome/free-solid-svg-icons";
import "./JobOfferTerms.scss";
import useJobOfferTerms from "./useJobOfferTerms";
import MainLayout from "../../Common/MainLayout";
export default (props) => {
  const {
    loading,
    loadingError,
    jobOfferTerms,
    isDeclineOfferModal,
    onAcceptJobOfferTermsClick,
    handleIsDeclineOfferModal,
  } = useJobOfferTerms(props);
  return (
    <MainLayout pageName={"Job Offer Terms"}>
      <div className="pb-5 create-interview-overview">
        <Container>
          <Row className="justify-content-center">
            {loading ? (
              <Spinner animation="border" variant="primary" />
            ) : (
              <Col className="col-md-12">
                {loadingError && loadingError.length > 0 ? (
                  <div className="col-6">
                    <p className="font-weight-bold">
                      Oops something went wrong.
                    </p>
                    <p className="font-weight-bold">{loadingError}</p>
                  </div>
                ) : (
                  <div className="bg-grey p-4">
                    <div className="d-flex align-items-center mb-4">
                      <div className="border-radius-10 mr-3 company-logo mt-4 pt-1">
                        <img src={"/assets/images/logo.png"} alt="user" />
                      </div>

                      <h2>
                        Job Offer Terms -{" "}
                        {jobOfferTerms?.job_application &&
                          jobOfferTerms.job_application?.job_details &&
                          jobOfferTerms.job_application.job_details?.title}
                      </h2>
                    </div>
                    <div className="inner-content">
                      <div className="row">
                        <div className="col-6">
                          <h4 className="alert alert-primary border-0 py-1 d-inline-block">
                            Offered By:{" "}
                            <span className="font-weight-bold">
                              {jobOfferTerms?.job_application &&
                                jobOfferTerms.job_application?.job_details &&
                                jobOfferTerms.job_application.job_details
                                  ?.posted_by_details &&
                                jobOfferTerms.job_application.job_details
                                  .posted_by_details?.company_details &&
                                jobOfferTerms.job_application.job_details
                                  .posted_by_details.company_details?.name}
                            </span>
                          </h4>
                        </div>
                        <div className="col-6 text-right">
                          <h3 className="alert alert-primary border-0 py-1 d-inline-block">
                            <span>Amount:</span>
                            {jobOfferTerms?.amount &&
                              jobOfferTerms.amount.toLocaleString()}
                          </h3>
                        </div>
                      </div>

                      <ul className="text-grey-4 d-flex border-bottom py-4">
                        <li className="mr-4">
                          <p className="text-dark-2 font-weight-semi">
                            POSITION
                          </p>
                          <p className="text-capitalize">
                            {jobOfferTerms?.job_application &&
                              jobOfferTerms.job_application?.job_details &&
                              jobOfferTerms.job_application.job_details?.title}
                          </p>
                        </li>
                        <li>
                          <p className="text-dark-2 font-weight-semi">
                            LOCATION
                          </p>
                          <p className="text-capitalize">
                            {jobOfferTerms?.job_application &&
                              jobOfferTerms.job_application?.job_details &&
                              jobOfferTerms.job_application.job_details
                                ?.city_name}{" "}
                            ,{" "}
                            {jobOfferTerms?.job_application &&
                              jobOfferTerms.job_application?.job_details &&
                              jobOfferTerms.job_application.job_details
                                ?.country_name}{" "}
                          </p>
                        </li>
                      </ul>

                      <div className="text-grey-4 pt-3">
                        {jobOfferTerms?.terms_conditions !== null ? (
                          <div
                            dangerouslySetInnerHTML={{
                              __html: jobOfferTerms?.terms_conditions,
                            }}
                          ></div>
                        ) : null}
                      </div>

                      <div className="py-4 text-grey-4">
                        <ul className="mb-4">
                          <li className="d-flex align-items-center">
                            <FontAwesomeIcon
                              icon={faCheckCircle}
                              className="text-primary mr-3"
                            />
                            Please read the offer terms carefully before
                            accepting the job offer.
                          </li>
                          <li className="d-flex align-items-center">
                            <FontAwesomeIcon
                              icon={faCheckCircle}
                              className="text-primary mr-3"
                            />
                            Feel free to reach out to the hiring manager in case
                            you want to make some amendments.
                          </li>
                          <li className="d-flex align-items-center">
                            <FontAwesomeIcon
                              icon={faCheckCircle}
                              className="text-primary mr-3"
                            />
                            Accepting the job offer means abiding by the company
                            guidelines and policies. date
                          </li>
                        </ul>
                        {jobOfferTerms?.offer_accepted === true ? (
                          <div className="actions d-flex align-items-center">
                            <Alert key={"primary"} variant={"primary"}>
                              <FontAwesomeIcon
                                icon={faInfoCircle}
                                className="mr-2"
                              />{" "}
                              You have accepted the job offer.
                            </Alert>
                          </div>
                        ) : jobOfferTerms?.offer_rejected === true ? (
                          <div className="actions d-flex align-items-center">
                            <Alert key={"danger"} variant={"danger"}>
                              <FontAwesomeIcon
                                icon={faInfoCircle}
                                className="mr-2"
                              />{" "}
                              You have rejected the job offer.
                            </Alert>
                          </div>
                        ) : (
                          <div className="actions d-flex align-items-center">
                            <button
                              className="btn btn-primary"
                              onClick={() => onAcceptJobOfferTermsClick(true)}
                            >
                              Accept
                            </button>
                            <button
                              className="btn btn-light border ml-3"
                              onClick={() => handleIsDeclineOfferModal()}
                            >
                              Decline
                            </button>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                )}
              </Col>
            )}
          </Row>
        </Container>

        <Modal
          show={isDeclineOfferModal}
          centered
          size="md"
          onHide={handleIsDeclineOfferModal}
          className="common-modal"
        >
          <Modal.Header closeButton>
            <Modal.Title>
              <h3>Reject Offer</h3>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="p-3 bg-white d-flex align-items-center justify-content-center flex-column">
            <h4>Are you sure you want to reject this offer?</h4>

            <div className="action mt-4">
              <button
                className="btn btn-primary px-5"
                onClick={() => onAcceptJobOfferTermsClick(false)}
              >
                Yes
              </button>
              <button
                className="btn btn-dark ml-4 px-5"
                onClick={() => handleIsDeclineOfferModal()}
              >
                Cancel
              </button>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    </MainLayout>
  );
};
